export const RequestHeaderHandler = headers => {
	headers.set('Access-Control-Allow-Origin', '*')
	headers.set('Accept', 'application/json')
	headers.set('authorization', `Bearer ${localStorage.token}`)
	if (localStorage?.organization) {
		headers.set('orgId', JSON.parse(localStorage?.organization)?.id)
	}
	return headers
}
